<script>
  export default {
    name: "ToggleDiv",
    data: () => ({
      isShow1: false,
      isShow2: false,
      isShow3: false,
      isShow4: false,
      isShow5: false,
      isShow6: false,
    }),

    props: {
      msg: String,
    },
  };
</script>
<template>

    <h1>Mittelohr - Aufbau und Funktion</h1>
     <div align="center" id="cardsWrapper"> 

      <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;">
        <!-- <h5 class="card-title">Aufbau - Grafik</h5> -->
        <div class="card-body" align="center">
          
        
           <img class="card-img-top" src="@/assets/Uebersicht_Ohr.jpg" alt="Card image cap">
          <br>
          <br>
          
        </div>
        
        
        <button class="btn btn-secondary"  @click="isShow1 = !isShow1" v-if="!isShow1">Weiter</button>
      </div>

      <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;" v-if="isShow1">
        <h5 class="card-title">Aufbau</h5>
        <div class="card-body" align="left">
            Das Mittelohr ist ein Hebelapparat, welcher aus drei Bestandteilen aufgebaut ist.
            <br>
            <br>
            Diese sind: <b>Hammer</b>, <b>Amboss</b> und <b>Steigbügel</b>, wobei die Form für die Namensgebung verantwortlich ist. 
            <br>
            <br>
            Die <b>Eustachische Röhre</b>  ist ebenfalls Bestandteil des Mittelohrs. 
            <br>
            <br>
            <div class="bild">
            <img class="card-img-top" src="@/assets/hebelapparat.png" alt="MittelohrDetail">
            </div>
            
            <br>
            <br>


            
          </div>
        <button class="btn btn-secondary"  @click="isShow2 = !isShow2" v-if="!isShow2">Weiter</button>
      </div>      

      <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;" v-if="isShow2">
          <h5>Funktion</h5>
          <div class="card-body" align="left">
          Die wichtigste Funktion ist die <b>Impedanzanpassung</b>  zwischen Luft und Lymphe, welche durch den Hebelapparat durchgeführt wird.
          <br>
          <br>
          Beim Übergang von Außenohr zu Mittelohr findet ein Wechsel des schallleitenden Mediums, <b>Luft → Lymphe</b>, statt und damit geht auch ein Wechsel von akustischer Impedanzen einher.
          <br>
          <br>
          Aufgrund der unterschiedlichen Schallwellenwiderstände würden so theoretisch etwa 98% der auftreffenden Schallwellen reflektiert werden, was die genannte Impedanzanpassung so wichtig macht.
          <br>
          <br>
          → Durch diese Anpassung kann die Reflexion auf ca. 40 % gesenkt werden
          <br>
          <br>
          → <b>Hebelwirkung</b> (Faktor 1,3) und <b>Flächenverhältnis</b> (14) ergeben eine <b>Gesamtverstärkung</b>  von ca. 15 (frequenzabhängig)
          <br>
          <br>
          </div>
          <button class="btn btn-secondary"  @click="isShow3 = !isShow3" v-if="!isShow3">Weiter</button>
      </div>
        
      <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;" v-if="isShow3">
        <h5 class="card-title">Funktion</h5>
        <div class="card-body" align="left">
          Das Mittelohr hat außerdem eine wichtige Schutzfunktion, den so genannten <b>Stapedius-Reflex</b> .
          <br>
          <br>
          → Regulieren der Sensibilität des Gehörsinns durch Muskelkontraktion (Stapediusreflexschwelle zwischen 75 und 100dB) 
          <br>
          <br>
          Letztlich sorgt die Eustachische Röhre für einen Druckausgleich zwischen Mittelohr und Nasen-Rachen Raum, was eine freie Schwingung des Trommelfells ermöglicht.
          <br>
          <br>
        </div>
        
      </div>  

    </div>
</template>
<style>
.bild{
  padding-left: 125px;
  padding-right: 125px;

}
</style>